import { getQueryParam } from '@vfde-sails/utils';
import { CATEGORY_QUERYPARAM } from '../../../app/constants';

/**
 * Get all filters from URL
 */
export const getFiltersFromUrl = (): string[] => {
    const filters = getQueryParam(CATEGORY_QUERYPARAM);

    if (filters) {
        const sanitizedFilters = filters.replace(/[^\w|,*]/gi, '');

        return sanitizedFilters.split(',');
    }

    return [];
};
